<ion-row>
    <ion-col size-xs="12">
        <ion-item lines="none">
            <span class="ion-text-wrap">
                <strong>{{ user.person.name }}<br></strong>
                <span *ngIf="!!user.person.email">{{ user.person.email }}<br></span>
                <span>{{ user.email }}<br></span>
                <span *ngIf="!!user.person.mobile">{{ user.person.mobile }}<br></span>
            </span>
        </ion-item>
    </ion-col>
</ion-row>
